export const MIN_ZOOM = 0.01
export const MAX_ZOOM = 8
